import classNames from 'classnames';
import React, { ReactNode } from 'react';
import { toast, ToastOptions } from 'react-toastify';

import { IconCheckmarkRound } from 'reactComponents/icons/checkMarkRound';
import { McsErrors } from 'reactComponents/McsErrors/McsErrors';

import styles from './ToastNotify.css';

export function success(text: ReactNode, options?: ToastOptions) {
    toast(
        <div
            className={styles.body}
            data-test="toast-notify toast-notify-success"
        >
            <IconCheckmarkRound
                className={classNames(styles.icon, styles.success)}
            />
            <div>{text}</div>
        </div>,
        options,
    );
}
export function error(text: ReactNode, options?: ToastOptions) {
    toast(
        <div
            className={classNames(styles.body, styles.error)}
            data-test="toast-notify toast-notify-error"
        >
            <div className={classNames(styles.icon, styles.notify__icon)} />
            <div>{text}</div>
        </div>,
        options,
    );
}

export function errorTryLater(text: ReactNode, options?: ToastOptions) {
    error(<McsErrors.TryLater>{text}</McsErrors.TryLater>, options);
}

export function errorCallSupport(text: ReactNode, options?: ToastOptions) {
    error(<McsErrors.CallSupport>{text}</McsErrors.CallSupport>, options);
}

export const ToastNotify = {
    success,
    error,
    errorTryLater,
    errorCallSupport,
};
